import { render, staticRenderFns } from "./MenuHead.vue?vue&type=template&id=12f8d69a&scoped=true"
import script from "./MenuHead.vue?vue&type=script&lang=js"
export * from "./MenuHead.vue?vue&type=script&lang=js"
import style0 from "./MenuHead.vue?vue&type=style&index=0&id=12f8d69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8d69a",
  null
  
)

export default component.exports